module.exports = __webpack_public_path__ + "fa-brands-400.woff?b9632c12f0da478fdd88ed9081d3f263";